import React from 'react';
import { dispatch } from '@rematch/core';
import { Portal, Image, List, Card, Button, Icon } from 'semantic-ui-react'
import { Container, Draggable } from 'react-smooth-dnd'
import TreeView from '@zippytech/react-toolkit/TreeView'
import '@zippytech/react-toolkit/TreeView/index.css'
import EllipsisTooltip from '../../../common/EllipsisTooltip';
import LabelWithCount from '../../../common/LabelWithCount';
import convertIcon from '../../../../helpers/convert-Icon';
import contentImage from '../../../../images/svg/noti-content.svg';
import ContentDetail from '../../contentManager/Drive/Modal/ContentDetail'

let components = [];

let getDataActivity = [];
let getDataContent = [];
class ContentTree extends React.Component {

    constructor() {
        super();
        this.state = {
            open: false,
        }
        this.onCollapsedChange = this.onCollapsedChange.bind(this)
    }
    componentWillReceiveProps(newProps) {
        if (this.props.selectedContent !== newProps.selectedContent) {
            this.setState({ content: newProps.selectedContent })
        }
    }

    handleOpen = async (e, data) => {
        this.setState({ open: true, top: e.clientY - 10, left: e.clientX + 20 })
        await dispatch.content.setSingleContent(data.item)
    }

    handleClose = () => {
        this.setState({ open: false })
    }

    openDialog = (isOpen) => {
        this.handleClose()
        this.setState({ isOpen: isOpen })
    }

    viewContentURL = (e, data) => {
        let redirectUrl = data.contentpath.indexOf('://') === -1 ? 'http://' + data.contentpath : data.contentpath
        window.open(redirectUrl, '_blank');
    }

    onDragStart = ({ payload }) => {

        if (payload !== null && payload !== undefined && payload !== 'undefined') {
            if (payload.draggableType === 'activity') {
                dispatch.lifeCycle.setIsDragableFlag('activity')
            } else if (payload.draggableType === 'content') {
                dispatch.lifeCycle.setIsDragableFlag('content')
            }
        }


    }

    onActivityDrop = () => {
        dispatch.lifeCycle.setIsDragableFlag(null)
    }

    onContentDrop = () => {
        dispatch.lifeCycle.setIsDragableFlag(null)
    }
    getElementToDrag = (i, index) => {
        return getDataContent[i]
    }
    createTreeData() {
        let activityArray = [];
        getDataActivity.map((p, i) => {
            activityArray.push(
                <Draggable key={i} >
                    <div className="draggable-item">
                        <EllipsisTooltip name={p.name} />
                    </div>
                </Draggable>
            );
        });
        let activityTree = [
            { label: <Container onDragStart={this.onDragStart} onDragEnd={this.onActivityDrop} groupName="ActivityCreation" behaviour="copy" getChildPayload={i => getDataActivity[i]} >{activityArray}</Container> }
        ]

        let contentArray = [];
        getDataContent.map((p, i) => {
            contentArray.push(
                {
                    label:
                        <Container
                            key={i}
                            onDragStart={this.onDragStart(2)}
                            onDragEnd={this.onContentDrop(2)}
                            groupName="Content"
                            behaviour="copy"
                            getChildPayload={index => this.getElementToDrag(i, index)} >

                            <Portal
                                closeOnPortalMouseLeave
                                closeOnTriggerMouseLeave
                                openOnTriggerMouseEnter
                                mouseEnterDelay={1500}
                                mouseLeaveDelay={100}
                                trigger={<Draggable >
                                    <div className="draggable-item browser-search-draggable"
                                        style={{
                                            textOverflow: "ellipsis",
                                            overflow: "hidden"
                                        }}>
                                        <Icon name={convertIcon(p.type)} />{p.name}
                                    </div>
                                </Draggable>}
                                item={p}
                                onOpen={this.handleOpen}
                                onClose={this.handleClose}
                            >
                                <Card
                                    style={{
                                        left: this.state.left,
                                        position: 'fixed',
                                        top: this.state.top,
                                        zIndex: 100,
                                        width: "360px",
                                        background: 'white',
                                    }}
                                >
                                    <Card.Content style={{ padding: "7px 10px" }} >
                                        <List >
                                            <List.Item>
                                                <List.Content floated='right'>
                                                    <span className="f_10">Publishing Level</span><br />
                                                    <b className="clr-green">{this.props.selectedContent.scope === "Public" ? "Public Library" : "Workspace Library"}</b>
                                                </List.Content>
                                                <Image
                                                    avatar
                                                    src={this.props.selectedContent.author && this.props.selectedContent.author.profilePic}
                                                />
                                                <List.Content>
                                                    <span className="f_10">Uploaded by</span>
                                                    <List.Header>
                                                        {this.props.selectedContent.author && this.props.selectedContent.author.firstName}&nbsp;
                                                        {this.props.selectedContent.author && this.props.selectedContent.author.lastName}
                                                    </List.Header>
                                                </List.Content>
                                            </List.Item>
                                        </List>
                                    </Card.Content>
                                    <Card.Content style={{ padding: "7px 10px" }} >

                                        <List >
                                            <List.Item>
                                                <Image style={{
                                                    height: "14px", float: "left",
                                                    width: '20px',
                                                    margin: "0 7px 0 0",
                                                    width: '20px'
                                                }} src={contentImage} />
                                                <List.Content style={{
                                                    margin: "0 0 0 5px", float: 'left',
                                                    width: 'calc(100% - 35px)'
                                                }}>
                                                    <span className="f_10">Content Name</span>
                                                    <List.Header>{p.name}</List.Header>
                                                </List.Content>
                                            </List.Item>
                                        </List>
                                    </Card.Content>
                                    <Card.Content style={{ padding: "7px 10px" }} extra>
                                        <Button
                                            size='mini'
                                            className="button-info"
                                            icon={convertIcon(this.props.selectedContent.type)}
                                            content={`${this.props.selectedContent.type}`}
                                            style={{ padding: "5px 10px" }}
                                            onClick={(e) => this.viewContentURL(e, this.props.selectedContent)} />
                                        <Button
                                            size='tiny'
                                            className="float-right button-submit"
                                            content="Details"
                                            style={{ padding: "5px 10px" }}
                                            onClick={() => this.openDialog(true)} />
                                    </Card.Content>
                                </Card>
                            </Portal>
                        </Container>
                }
            );
        });
        if (this.props.publishedContent && this.props.publishedContent.total > 10 && this.props.publishedContent.total !== getDataContent.length) {
            contentArray.push({
                label: <Button
                    className="button-info"
                    size='tiny'
                    style={{ width: "calc(100% - 5px)" }}
                    onClick={() => this.props.setDataAsPerCategory(getDataContent.length + 10)}>Load More</Button>
            });
        }
        // let contentTree = [
        //     { label: <Container onDragStart={this.onDragStart(2)} onDragEnd={this.onContentDrop(2)} groupName="Content" behaviour="copy" getChildPayload={i => getDataContent[i]} >{contentArray}</Container> }
        // ]
        let act = {
            label: <LabelWithCount label="Activities" count={getDataActivity.length > 0 ? getDataActivity.length : 0} />,
            nodes: activityTree
        }

        let cnt = {
            label: <LabelWithCount label="Content" count={this.props.publishedContent && this.props.publishedContent.total !== 0 ? this.props.publishedContent.total : 0} />,
            nodes: contentArray
        }

        components = []
        if (this.props.selectedDataById && (this.props.selectedDataById.status === 0 || this.props.selectedDataById.isCopy)) {
            components.push(act)
        }
        components.push(cnt)

    }
    getActivityList() {
        getDataActivity = []
        this.props.activityList && this.props.activityList.map(function (item, i) {
            item.id = item._id;
            item.type = 'activity';
            item.draggableType = 'activity'
            if (item.isLeafNode)
                getDataActivity.push(item);

        })
    }

    setContentList() {
        getDataContent = []
        this.props.publishedContent && this.props.publishedContent.data && this.props.publishedContent.data.map(function (item, i) {
            getDataContent.push({
                id: item._id,
                name: item.name,
                scope: item.scope,
                type: item.type,
                contentpath: item.contentpath,
                draggableType: 'content'
            });

        })
    }

    onCollapsedChange({ ...nodeProps }) {
        if (nodeProps.indexPath === 0) {
            this.setState({ collapsed: { '0': false, '1': true, } })
        } else if (nodeProps.indexPath === 1) {
            this.setState({ collapsed: { '0': true, '1': false, } })
        }
    }

    render() {
        this.getActivityList();
        this.setContentList();
        this.createTreeData();
        return (
            <span>
                <TreeView
                    collapsed={this.state.collapsed}
                    className="activityList browserPane noHoverEffect"
                    defaultCollapsedDepth={0}
                    dataSource={components}
                    enableHoverStyle={false}
                    onCollapsedChange={this.onCollapsedChange}
                    enableKeyboardNavigation={false}
                />
                <ContentDetail
                    isOpen={this.state.isOpen}
                    content={this.state.content}
                    openDialog={this.openDialog}
                />
            </span>
        );
    }
}
export default ContentTree;